import React from 'react';
import { twMerge } from 'tailwind-merge';
import { trackCheckoutStart } from '../lib/metaPixel';
import { PAYMENT_NOTE, PRICE } from '../data/content';

/** The checkout — opened only by the button under the price. */
export const CHECKOUT_URL = 'https://browinstructorready.impultienda.ar/checkout';

/** The other buttons scroll to the price + checkout button. */
export const CHECKOUT_BLOCK_ID = 'checkout-button';
interface CtaButtonProps {
  label: string;
  /** 'checkout' opens the checkout; 'scroll' goes to the checkout button. */
  action?: 'checkout' | 'scroll';
  className?: string;
}
export function CtaButton({
  label,
  action = 'scroll',
  className = ''
}: CtaButtonProps) {
  const isCheckout = action === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : `#${CHECKOUT_BLOCK_ID}`} onClick={isCheckout ? trackCheckoutStart : undefined} className={twMerge('group inline-flex items-center justify-center gap-2.5 rounded-[14px] bg-brand-cta px-8 py-[18px] text-center font-body text-[14px] font-bold uppercase tracking-[0.06em] text-brand-cta-text shadow-[0_5px_0_0_#3A5538,0_18px_34px_-14px_rgba(72,103,70,0.7)] transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-brand-cta-dark active:translate-y-[3px] active:shadow-[0_2px_0_0_#3A5538] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-cta focus-visible:ring-offset-2 focus-visible:ring-offset-brand-ivory sm:text-[15px]', className)} data-id="element-1" data-mp="vbsgjqlogyda">
      <span data-id="element-2" data-mp="3swtzbh8k15bj">{label}</span>
      <span aria-hidden="true" className="text-base font-normal transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-3" data-mp="3swap6mp5bl82">
        →
      </span>
    </a>;
}

/** The only place the price appears — directly above the checkout button. */
export function CheckoutBlock({
  label,
  className = ''
}: {
  label: string;
  className?: string;
}) {
  return <div id={CHECKOUT_BLOCK_ID} className={`flex scroll-mt-[18vh] flex-col items-center text-center ${className}`} data-id="element-4" data-mp="gh9vx9rthxv8">
      <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-gold" data-id="element-5" data-mp="3mxqk9z6kgshi">
        Complete System · Today
      </p>
      <p className="mt-2 font-body text-[3.25rem] font-bold leading-none tracking-[-0.02em] text-brand-charcoal sm:text-[3.75rem]" data-id="element-6" data-mp="ie8hs4iw05k">
        {PRICE}
      </p>
      <p className="mt-3 font-body text-[11px] uppercase tracking-[0.14em] text-brand-charcoal/55" data-id="element-7" data-mp="3rugzyleglm2e">
        {PAYMENT_NOTE}
      </p>
      <CtaButton label={label} action="checkout" className="mt-6 w-full sm:w-auto sm:min-w-[440px]" data-id="element-8" data-mp="4jq0g4avcxgx" />
      <p className="mt-4 font-body text-[12px] text-brand-charcoal/55" data-id="element-9" data-mp="jggr9p6h90ux">
        Instant access to Brow Instructor Ready™
      </p>
    </div>;
}